import React, { useState } from "react";
import './download_app.css'
import { Link } from "react-router-dom";

const Download_app = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [isHoveredRight, setIsHoveredRight] = useState(false);
    const [isHoveredLeft, setIsHoveredLeft] = useState(false);
    const [isHoveredImage, setIsHoveredImage] = useState(false);
    const [isHoveredBg, setIsHoveredBg] = useState(false);
    const [isHoveredUpTl, setIsHoveredUpTl] = useState(false);

    return (
        <>
            <div className="Download_App">
                <div className="container">


                    <div
                        className="Download_App_content_holder "
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                        <div className="row w-100">
                            <div className="col-md-6">
                                <div className="text_content">
                                    <div>
                                        <div className="main_heading_holder">

                                            <h1 className="lefthead">
                                                HEALTHY LIFESTYLE <br />IN JUST A TAP
                                            </h1>

                                            {/* <h1 className="firstText">
                                                 HEALTHY LIFESTYLE<br /> IN JUST A TAP
                                            </h1> */}

                                            {/* <h1
                                                className={`secondText ${isHovered ? "slide-right " : "slide-right-reverse "
                                                    }`}
                                                onMouseEnter={() => setIsHoveredRight(true)}
                                                onMouseLeave={() => setIsHoveredRight(false)}
                                            >
                                                HEALTHY LIFESTYLE<br /> IN JUST A TAP
                                            </h1> */}
                                        </div>

                                        <div className="subheading_holder">
                                            <h2>Download the App</h2>
                                        </div>

                                        <div className="get_app_holder">


                                            <div className="img-holder">
                                                <Link target="_blank" to="https://play.google.com">
                                                    <img
                                                        className="app_img"
                                                        src={
                                                            process.env.PUBLIC_URL +
                                                            "/assets/images/icons/googleplay.png"
                                                        }
                                                        alt="app_img"
                                                    />
                                                </Link>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="main-img-holder">
                                    <div
                                        className={`bg-img-holder ${isHovered
                                            ? "rotate-center-bg"
                                            : "rotate-center-bg-Reverse"
                                            }`}
                                        onMouseEnter={() => setIsHoveredBg(true)}
                                        onMouseLeave={() => setIsHoveredBg(false)}
                                    >
                                        <img
                                            className="mobile_bg_img"
                                            src={
                                                process.env.PUBLIC_URL +
                                                "/assets/images/home/download-app/bg.png"
                                            }
                                            alt="mobile_bg_img"
                                        />
                                    </div>

                                    <div className="overlay-img-holder">
                                        <div
                                            className={`img-holder single_mobile ${isHovered ? " rotate-center " : "rotate-center-Reverse"
                                                }`}
                                            onMouseEnter={() => setIsHoveredImage(true)}
                                            onMouseLeave={() => setIsHoveredImage(false)}
                                        >
                                            <img
                                                className="mobile_img"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/images/home/download-app/mobile-2.png"
                                                }
                                                alt="mobile_img"
                                            />
                                        </div>

                                        <div
                                            className={`img-holder grp_mobile ${isHovered ? " rotate-center " : "rotate-center-Reverse"
                                                }`}
                                            onMouseEnter={() => setIsHoveredImage(true)}
                                            onMouseLeave={() => setIsHoveredImage(false)}
                                        >
                                            <img
                                                className="mobile_img"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/images/home/download-app/mobile-2.png"
                                                }
                                                alt="mobile_img"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Download_app